import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Wizard } from "./screens/Wizard";

/**
 * Bare or partial URLs (e.g. `/`, `/noos-hotel/`, anything not matching the
 * `/:workspace/:token` shape) render NOTHING — no copy, no helpful prompt, no
 * shell. Roman: "I do not want anything to be rendered here." Search engines
 * stay out (noindex) so the bare host doesn't leak into results either.
 */
function BlankNotFound() {
  useEffect(() => {
    document.title = "";
    const existing = document.querySelector('meta[name="robots"]');
    if (existing) {
      existing.setAttribute("content", "noindex, nofollow");
    } else {
      const meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "noindex, nofollow";
      document.head.appendChild(meta);
    }
  }, []);
  return null;
}

export function App() {
  return (
    <Routes>
      <Route path="/:workspace/:token" element={<Wizard />} />
      <Route path="*" element={<BlankNotFound />} />
    </Routes>
  );
}
